import React from 'react'
import './Main.css'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useAnimation } from 'framer-motion';

import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

import Carousel from 'react-bootstrap/Carousel';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ax1 from '../../content/project-10.jpg'
import ax2 from '../../content/project-48.jpg'
import ax3 from '../../content/project-16.jpg'
import ax4 from '../../content/project-50.jpg'
import ax5 from '../../content/main5-low.jpg'
import ax6 from '../../content/pattern12.png'
import ax7 from '../../content/onyx1-low.jpg'
import ax8 from '../../content/onyx2-low.jpg'
import ax9 from '../../content/onyx13-low.jpg'
import extractionSymbol from '../../content/extractionSymbol2.png'
import stoneProcess from '../../content/stoneProcess.png'
import transportation from '../../content/transportation1.png'
import onyx10 from '../../content/onyx10-low.jpg'
import marble from '../../content/marble3-1-low.jpg'
import marmar from '../../content/marmar26-2-low.jpg'
import Jasmin from '../../content/Jasmin-low.jpg'
import crystal from '../../content/crystal-mainPage-low.jpg'
import greenCrystal from '../../content/greenCrystal-low.jpg'
import lightStone1 from '../../content/project-52.jpg'
import sample4 from '../../content/sample4-low.jpg'
import pattern1Small from '../../content/pattern1-small.jpg'
import pattern2Small from '../../content/pattern2-small.jpg'
import pattern6Small from '../../content/pattern6-small.jpg'
import project36 from '../../content/project-36.jpg'
import MaintainingLuxuriousElegance from '../../content/MaintainingLuxuriousElegance.jpg'
import EmbracingSustainability from '../../content/EmbracingSustainability1.jpg'
import ModernDesign from '../../content/ModernDesign.jpg'



function Main() {

    const {ref, inView} = useInView({
      threshold: 0.3
    });
    const animationLeft = useAnimation();
    const animationRight = useAnimation();




    useEffect(() => {
      if(inView){
        animationLeft.start({
          x:0,
          transition: {
            type:'spring', duration: 2, bounce: 0.3
          }
        })

        animationRight.start({
          x:0,
          transition: {
            type: 'spring', duration: 2, bounce: 0.3
          }
        })
      }

      if(!inView){
        animationLeft.start({x: '-100vw'})
        animationRight.start({x: '100vw'})
      }
    }, [inView])



    const { pathname } = useLocation();
  
      useEffect(() => {
        window.scrollTo(0, 0);
      }, [pathname]); 

      
  return (
    <div className='Main'>
      <div className='web-body'>
          <div ref={ref} className='ImageSlider'>
            <Carousel fade>
              <Carousel.Item>
                <img className='carousel-image' src={ax1} />
              </Carousel.Item>
              <Carousel.Item>
                <img className='carousel-image' src={ax2} />
              </Carousel.Item>
              <Carousel.Item>
                <img className='carousel-image' src={ax3} />
              </Carousel.Item>
              <Carousel.Item>
                <img className='carousel-image' src={ax4} />
              </Carousel.Item>
              <Carousel.Item>
                <img className='carousel-image' src={ax5} />
              </Carousel.Item>
              <Carousel.Item>
                <img className='carousel-image' src={ax6} />
              </Carousel.Item>
              <Carousel.Item>
                <img className='carousel-image' src={ax7} />
              </Carousel.Item>
              <Carousel.Item>
                <img className='carousel-image' src={ax8} />
              </Carousel.Item>
              <Carousel.Item>
                <img className='carousel-image' src={ax9} />
              </Carousel.Item>
            </Carousel>
          </div>

        
          <Container ref={ref} fluid className='sampleText-container'>
            <Row className='sampleText-xs-row-1'>
              <Col xs={7} lg={8}>
                <motion.div className='sampleText' animate={animationLeft}>
                  <h1 className='sampleHeading'>Discover the beauty and versatility</h1>
                  <p className='sampleText-p2'>At <stan style={{color:'orangered'}}>ABAR Stone</stan> we manufacture
                  stones extracted from our own quarries and supply some of the best stones available in Iran from our 
                  trusted sources</p>
                </motion.div>
              </Col>
              <Col xs={{pr:0}} className="extractionSymbol-col"><motion.img animate={animationRight} className='extractionSymbol' src={extractionSymbol} /></Col>
            </Row>
          

            <Row className='sampleText-xs-row-2 mr-0 ml-0'>
              <Row>
                <Col>
                  <motion.h1 className='sampleHeading' animate={animationLeft}> Discover the beauty and versatility</motion.h1>
                </Col>
              </Row>
              <Row>
                <Col xs={7} style={{paddingLeft:'46px'}}>
                  <motion.p animate={animationLeft} className='sampleText-p2'>At <stan style={{color:'orangered'}}>ABAR Stone</stan> we manufacture
                  stones extracted from our own quarries and supply some of the best stones available in Iran from our 
                  trusted sources</motion.p>
                </Col>
                <Col style={{padding:'0'}}><motion.img  animate={animationRight} className='extractionSymbol' src={extractionSymbol} /></Col>
              </Row>
            </Row>
          </Container>


          <Container fluid className='group-image-container'>
            <Row>
              <Col xs={6} lg={3}>
                <Link to='marble'><img className='groupImage' src={marble} /></Link>
                <h5>Marble</h5>
              </Col>
              <Col xs={6} lg={3}>
                <Link to='crystal'><img className='groupImage' src={crystal} /></Link>
                <h5>Crystal</h5>
              </Col>
              <Col xs={6} lg={3}>
                <Link to='granite'><img className='groupImage' src={Jasmin} /></Link>
                <h5>Granite</h5>
              </Col>
              <Col xs={6} lg={3}>
                <Link to='onyx'><img className='groupImage' src={marmar} /></Link>
                <h5>Onyx</h5>
              </Col>  
            </Row>
          </Container>


          <Container fluid className='enchantingBeauty-container'>
            <Row>
              <Col xs={12} lg={6}><h1 className='greenstone-text'>The Enchanting Beauty of Natural Stone</h1></Col>
              <Col className='greenstone-image'>
                <img className='structuredFinish' src={greenCrystal} />
                <Link to='greenParadise2'><div className='greenstone-image-inside'></div></Link>
              </Col>
            </Row>
          </Container>



          <Container fluid className='whereLightMeets-container'>
            <Row>
              <Col><img className='whereLightMeets-image' src={lightStone1} /></Col>
              <Col xs={12}><h1 className='whereLightMeets-text'>" Where Light Meets Stone "</h1></Col>
            </Row>
          </Container>



          <Container fluid className='onyx10-container p-0'>
            <Row>
              <Col><img className='onyx10' src={onyx10} /></Col>
            </Row>
          </Container>


          <Container fluid className='landingPage-description-container'>
            <Row>
              <Col>
                <div className='landingPage-description'>
                  <h4 className='landingPage-description-heading-1'>WHO we are  . . .</h4>
                  <h2 className='landingPage-description-heading-2'>From Quarry to Elegance: Your One-Stop Shop for Travertine and other Natural Stones</h2>
                  <p className='landingPage-description-p-1'>
                    We transform some of the Iran's finest stones into stunning slabs and tiles, perfect for your next project.
                    We are a stone manufacturer , managing the entire process from extracting the raw materials directly from our quarries to crafting it into beautiful finished products.
                    In addition to our stones, we also offer a variety of other natural stones from Iran
                  </p>
                  <p className='landingPage-description-p-2'> Browse our exquisite selection of stones or contact us for a custom quote today!</p>
                </div>
              </Col>
            </Row>
            <Row className='mt-5 mb-5'>
              <Col><img className='symbols' src={extractionSymbol} /></Col>
              <Col><img className='symbols' src={stoneProcess} /></Col>
              <Col><img className='symbols' src={transportation} /></Col>
            </Row>
          </Container>





          <Container fluid className='textureSection-container' style={{position:'relative', paddingBottom:'100px', paddingTop:'50px', backgroundColor:'white'}}>
            <Row>
              <Col xs={12} lg={7} className='textureSection-col-1'><img src={sample4} /></Col>
              <Col  className='textureSection-col-2'>
                <h2 className='texture-heading'>Elevate Your Projects with Exquisitely Finished Natural Stone</h2>
                <div className='textures'>
                  <Container>
                    <Row>
                      <Col>
                        <img className='textureSection-image' src={pattern1Small} />
                        <p>Fly pattern texture</p>
                      </Col>
                      <Col>
                        <img className='textureSection-image' src={pattern2Small} />
                        <p>Rock texture</p>
                      </Col>
                      <Col>
                        <img className='textureSection-image' src={pattern6Small} />
                        <p>Velvet texture</p>
                      </Col>
                    </Row>
                  </Container>
                  <Link to='/textures'><button className="button5">E X P L O R E</button></Link>
                </div>
              </Col> 
            </Row>
          </Container>


          <Container fluid className='projects-container' >
            <Row className='m-0 p-0'>
              <Col className='projects-col p-0'>
                <div className='projects-overlay'></div>
                <hr></hr>
                <h1 className='projects-heading'>P R O J E C T S</h1>
                <hr></hr>
                <img className='project36' src={project36} />
                <Link to='/projects'><button className="projects-button">E X P L O R E</button></Link>
              </Col>
            </Row>
          </Container>


          <Container fluid className='blogs-container'>
            <hr></hr>
            <h1 className='blogs-Heading'>B L O G S</h1>
            <hr></hr>
            <Swiper
              slidesPerView={2}
              spaceBetween={10}
              centeredSlides={true}
              // autoplay={true}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
              }}
              modules={[Pagination]}
              className="mySwiper"
            >
                    
                    
              <SwiperSlide>
                <Link to='blog3'><img  src={MaintainingLuxuriousElegance} /></Link>
                <p className='blogs-text'>Maintaining Luxurious Elegance</p>
              </SwiperSlide>
              <SwiperSlide>
                <Link to='blog2'><img  src={EmbracingSustainability} /></Link>
                <p className='blogs-text'>Embracing Sustainability: A Growing Trend in the Building Stone Industry</p>
              </SwiperSlide>
              <SwiperSlide>
                <Link to='blog1'><img  src={ModernDesign} /></Link>
                <p className='blogs-text'>The Rise of Architectural Stone: A Modern Design Trend</p>
              </SwiperSlide>
            </Swiper>
          </Container>

          <div className='transparent'></div>

      </div>
    </div>
  )
}

export default Main
